import { useEffect } from "react";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { PRACTITIONER } from "@/core/constants";
import { CREATE_PRACTITIONER_PROFILE_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";

import Common from "./CommonForm";

export default function LoggedInForm({ setFormSubmitted }) {
  const { patientProfile } = useUserProfileContext();

  const api = useDjangoGraphqlForm({
    transformer: input => ({
      ...input,
      professionalBodies: input.professionalBodies.join(","),
      documents: JSON.stringify(
        input.documents.reduce((acc, doc) => {
          if (doc.type in acc) {
            return {
              ...acc,
              [doc.type]: [
                ...acc[doc.type],
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          } else {
            return {
              ...acc,
              [doc.type]: [
                {
                  key: doc.key,
                  name: doc.name,
                  qualification_type: doc.qualification_type
                }
              ]
            };
          }
        }, {})
      )
    }),
    mutation: CREATE_PRACTITIONER_PROFILE_MUTATION,
    mutationName: "createPractitionerProfileMutation",
    defaultValues: {
      tier: PRACTITIONER,
      firstName: patientProfile?.user?.firstName || "",
      lastName: patientProfile?.user?.lastName || "",
      email: patientProfile?.user?.email || "",
      dateOfBirth: patientProfile?.dateOfBirth || "",
      gender: patientProfile?.gender || "",
      practitionerType: "",
      professionalBodies: [],
      documents: [],
      phoneNumber: "",
      jobRole: "",
      businessName: "",
      specialisms: [],
      businessLocationCity: "",
      businessCountry: "",
      acceptTerms: false
    },
    handleSuccess: () => {
      setFormSubmitted(true);
    }
  });

  useEffect(() => {
    if (patientProfile) {
      api.methods.reset({
        tier: PRACTITIONER,
        firstName: patientProfile?.user?.firstName || "",
        lastName: patientProfile?.user?.lastName || "",
        email: patientProfile?.user?.email || "",
        dateOfBirth: patientProfile?.dateOfBirth || "",
        gender: patientProfile?.gender || "",
        practitionerType: "",
        professionalBodies: [],
        documents: [],
        phoneNumber: "",
        jobRole: "",
        businessName: "",
        specialisms: [],
        businessLocationCity: "",
        businessCountry: "",
        acceptTerms: false
      });
    }
  }, [patientProfile]);

  return (
    <Common
      api={api}
      readOnlyFields={["firstName", "lastName", "email", "gender", "dateOfBirth"]}
    />
  );
}
